import { modalRenderer } from '~/modal/modalRendererRegistry';
import { MigrateMapsInProgressComponent } from './migrateMapsInProgress.component';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    MigrationInProgress: undefined;
  }
}

modalRenderer.register('MigrationInProgress', (props) => <MigrateMapsInProgressComponent {...props} />);
